import { Chakra } from "@airhelp/react-ui-components";
import PropTypes from "prop-types";
import { useTranslations } from "contexts/LocalizationContext/hooks";
import MenuLink from "modules/common/components/MenuLink";
import useDeviceSize from "hooks/useDeviceSize";
import MenuLinkWithSubmenuDesktop from "./MenuLinkWithSubmenuDesktop";
import MenuLinkWithSubmenuMobile from "./MenuLinkWithSubmenuMobile";

const { Box } = Chakra;

const MenuItems = ({ menu }) => {
  const translations = useTranslations();
  const { isDesktop } = useDeviceSize();

  const menuLinksMapped = menu.map((item) => {
    const { subMenu, label } = item;

    const menuLink = (
      <MenuLink
        variant="footerDark"
        menuItem={item}
        linkType={subMenu ? "span" : ""}
        fontWeight="semibold"
        py={{ base: 4, lg: 0 }}
        display="block"
      />
    );

    return (
      <Box key={translations(label)} ml={{ lg: 9 }}>
        {subMenu ? (
          <>
            {isDesktop ? (
              <MenuLinkWithSubmenuDesktop menulink={menuLink} submenu={subMenu} />
            ) : (
              <MenuLinkWithSubmenuMobile menulink={menuLink} submenu={subMenu} />
            )}
          </>
        ) : (
          menuLink
        )}
      </Box>
    );
  });

  return <>{menuLinksMapped}</>;
};

export default MenuItems;

MenuItems.propTypes = {
  menu: PropTypes.arrayOf(
    PropTypes.shape({
      page: PropTypes.string,
      label: PropTypes.string.isRequired,
      prefetch: PropTypes.bool,
    })
  ).isRequired,
};
